<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-img
        :src="require('@/assets/logo.png')"
        contain
        max-width="200"
        width="100%"
        class="pb-6"
      />

      <!-- <base-title
        size="body-1"
        space="4"
        title="MULTI-PURPOSE THEME"
        weight="regular"
      /> -->

      <!-- <base-body>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Illo pariatur
        quidem, quis modi iure nihil commodi suscipit, corporis dicta adipisci,
        voluptatum quia cupiditate. Nulla minus voluptatum nostrum deleniti,
        asperiores facere.
      </base-body> -->

      <!-- <base-btn class="mb-12" color="white" outlined>
        More Info
      </base-btn> -->

      <a
        :text="'About Us'"
        class="mb-8 grey--text body-1 d-block text-none"
        href="#"
        v-html="'&rsaquo; About Us'"
      />

      <a
        :text="'Privacy Policy'"
        class="mb-8 grey--text body-1 d-block text-none"
        href="#"
        v-html="'&rsaquo; Privacy Policy'"
      />

      <a
        :text="'Privacy Policy'"
        class="mb-8 grey--text body-1 d-block text-none"
        href="#"
        v-html="'&rsaquo; Privacy Policy'"
      />

      <a
        class="mb-8 grey--text body-1 d-block text-none"
        href="#"
        v-html="'Copyright © 2020'"
      />
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseInfo",

  props: {
    title: String,
    dark: Boolean,
  },
};
</script>

<style scoped>
.text-size {
  font-size: 16px;
}
</style>
